import React from 'react'
import { useNavigate } from 'react-router-dom';
import Button from '../../Subcomponents/Button';
import Datagrid from '../../Subcomponents/Datagrid';
import SearchBar from '../../Subcomponents/Search';
import cssClasses from './SelectSalesCp.module.css'
import AddIcon from '@mui/icons-material/Add';
import { CheckBox } from '@mui/icons-material';
import { Checkbox } from '@mui/material';

export default function SelectSalesCp({ allChildRows, selectAll, deSelectAll, setSearchSalesCp, pageChanged, allRows, allColums, id, type = 'Sales/Cp' }) {
    const navigate = useNavigate()

    return (
        <div className={cssClasses.mainContainer}>
            <div className={cssClasses.content}>
                <div className={cssClasses.actionWrapper}>
                    <div className={cssClasses.searchWrapper} style={{ marginBottom: "1.6rem" }}>
                        <SearchBar placeholder={type === 'Sales/Cp' ? "Search by name" : "Search by token name"} search={(e) => { setSearchSalesCp(e.target.value) }} id={id} />
                    </div>
                  
                     <>
                     {allChildRows.length > 0 &&
                         <div style={{
                             display: 'flex',
                             fontSize: '1.4rem',
                             gap: "2rem"
                         }}>
                             <div style={{
                                 display: 'flex',
                                 alignItems: 'center'
                             }}>
                                 <Checkbox style={{ width: "1.4rem", height: "1.4rem" }} checked={allChildRows?.filter((e) => { return e.isSelected === true }).length === allChildRows?.length ? true : false} onChange={selectAll} />
                                 <p onClick={selectAll} style={{ cursor: "pointer" }}>Select All</p>
                             </div>
                             <div style={{
                                 display: 'flex',
                                 alignItems: 'center'
                             }}>
                                 <Checkbox style={{ width: "1.4rem", height: "1.4rem" }} checked={allChildRows?.filter((e) => { return e.isSelected === false }).length === allChildRows?.length ? true : false} onChange={deSelectAll} />
                                 <p onClick={deSelectAll} style={{ cursor: "pointer" }}>Deselect All</p>
                             </div>
                         </div>
                     }
                     </>

                    
                   
                    
                    {/* {type === 'Sales/Cp' &&
                        <div className={cssClasses.btnWrapper} style={{ marginBottom: "1.6rem" }}>
                            <Button clicked={() => { navigate('/home/Event/') }} btnName={'Add Project'} btnIcon={<AddIcon style={{ width: "2rem", height: "2rem" }} />} style={{ borderRadius: "0.4rem", backgroundColor: "#1570EF", color: "#FFFFFF", fontSize: "1.6rem" }} padding={"0.5rem 1rem"} iconPosition={"left"} />
                        </div>
                    } */}
                </div>
                <div className={cssClasses.gridWrapper}>
                    <Datagrid pageChanged={pageChanged} hideFooter={false} columns={allColums} rows={allRows ? allRows : []} />
                </div>
            </div>
        </div>
    )
}
